export default function (axios, config) {
  const importMap = function (row) {
    return {
      id: row.id,
      date: row.field_datum,
      field_status_volksstaerke: 1 * row.field_status_volksstaerke || 0,
      field_status_raumreserve: 1 * row.field_status_raumreserve || 0,
      field_status_weiselrichtigkeit: 1 * row.field_status_weiselrichtigkeit || 0,
      field_status_sanftmut: 1 * row.field_status_sanftmut || 0,
      field_status_schwarmstimmung: 1 * row.field_status_schwarmstimmung || 0,
      field_status_futterversorgung: 1 * row.field_status_futterversorgung || 0,
      field_status_gesundheit: 1 * row.field_status_gesundheit || 0,
      field_status_varroabeurteilung: 1 * row.field_status_varroabeurteilung || 0
    }
  }

  return {
    invalidate () {
      this.getAll.invalidate()
      this.getOne.invalidate()
    },
    getAll: config.cachedFunction(async function (colony) {
      const response = await axios({
        url: config.serverUrl + '/api/node/' + colony + '?_format=json',
        method: 'get',
        withCredentials: true
      })

      const colonyData = Object.values(response.data.result)[0]

      if (!colonyData || !colonyData.field_massnahmen_und_aktionen) return []

      return Object.values(colonyData.field_massnahmen_und_aktionen)
        .filter(function (row) {
          return row.type === 'status'
        })
        .map(function (row) {
          return importMap(row)
        })
        .sort(function (rowA, rowB) {
          if (rowA.date < rowB.date) {
            return 1
          }
          if (rowA.date > rowB.date) {
            return -1
          }

          return 0
        })
    }),
    getOne: config.cachedFunction(async function (id) {
      const response = await axios({
        url: config.serverUrl + '/api/paragraph/' + id + '?_format=json',
        method: 'get',
        withCredentials: true
      })

      if (!response.data.result) return null

      const row = Object.values(response.data.result)[0]
      return importMap(row)
    }),
    // eslint-disable-next-line camelcase
    async save ({ id, colony, date, token, field_status_volksstaerke, field_status_raumreserve, field_status_weiselrichtigkeit, field_status_sanftmut, field_status_schwarmstimmung, field_status_futterversorgung, field_status_gesundheit, field_status_varroabeurteilung }) {
      this.invalidate()
      const data = {
        field_datum: date,
        type: 'status',
        field_status_volksstaerke,
        field_status_raumreserve,
        field_status_weiselrichtigkeit,
        field_status_sanftmut,
        field_status_schwarmstimmung,
        field_status_futterversorgung,
        field_status_gesundheit,
        field_status_varroabeurteilung
      }

      const url = (id ? config.serverUrl + '/api/paragraph/' + id + '?_format=json' : config.serverUrl + '/api/node/' + colony + '?_format=json')
      console.log(url)
      const ratingResult = await axios({
        url,
        method: 'patch',
        data: (id ? data : {
          field_massnahmen_und_aktionen: [data]
        }),
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })

      const rating = Object.values(ratingResult.data.result)[0]

      if (id) {
        // patch colony to reset Drupal-cache
        await axios({
          url: config.serverUrl + '/api/node/' + colony + '?_format=json',
          method: 'patch',
          data: {},
          withCredentials: true,
          headers: {
            'X-CSRF-Token': token
          }
        })
      }

      return rating
    },
    async delete ({ id, colony, token }) {
      // const url = (id ? config.serverUrl + '/api/paragraph/' + id + '?_format=json' : config.serverUrl + '/api/node/' + colony + '?_format=json')
      const url = config.serverUrl + '/api/paragraph/' + id + '?_format=json'
      console.log(url)
      const ratingResult = await axios({
        url,
        method: 'delete',
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
      console.log(ratingResult)
      const rating = Object.values(ratingResult.status)
      if (id) {
        // patch colony to reset Drupal-cache
        await axios({
          url: config.serverUrl + '/api/node/' + colony + '?_format=json',
          method: 'patch',
          data: {},
          withCredentials: true,
          headers: {
            'X-CSRF-Token': token
          }
        })
      }
      console.log('end delete')
      return rating
    }
  }
}
